import React, { useMemo, useState } from "react";
import { Container, Card, Button, Table } from "react-bootstrap";
import {
    ArrowLeft,
    Download,
    ChevronDown,
    ChevronUp,
    ArrowUpCircle,
    ArrowDownCircle,
} from "react-bootstrap-icons";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { useNavigate } from "react-router-dom";

const CustomerReturnTimeDetails = () => {
    const navigate = useNavigate();
    const [showMore, setShowMore] = useState(false);
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const [hoveredBar, setHoveredBar] = useState(null);

    const monthlyData = [
        { month: "Jun '25", days: 3, customers: 120 },
        { month: "Jul '25", days: 4, customers: 160 },
        { month: "Aug '25", days: 5, customers: 210 },
        { month: "Sep '25", days: 4, customers: 185 },
        { month: "Oct '25", days: 6, customers: 230 },
        { month: "Nov '25", days: 5, customers: 260 },
        { month: "Dec '25", days: 6, customers: 290 },
        { month: "Jan '26", days: 7, customers: 320 },
        { month: "Feb '26", days: 7, customers: 390 },
        { month: "Mar '26", days: 8, customers: 430 },
        { month: "Apr '26", days: 9, customers: 510 },
        { month: "May '26", days: 11, customers: 610 },
        { month: "Jun '26", days: 13, customers: 693 },
    ];

    const visitData = [
        { visit: "1-2", days: 4, customers: 1443 },
        { visit: "2-3", days: 3, customers: 770 },
        { visit: "3-4", days: 2, customers: 537 },
        { visit: "4-5", days: 2, customers: 426 },
        { visit: "5-6", days: 2, customers: 342 },
        { visit: "6-7", days: 1, customers: 301 },
        { visit: "7-8", days: 2, customers: 253 },
        { visit: "8-9", days: 1, customers: 218 },
        { visit: "9-10", days: 1, customers: 196 },
        { visit: "10-11", days: 1, customers: 177 },
        { visit: "12-13", days: 1, customers: 140 },
    ];

    const current = monthlyData[monthlyData.length - 1];
    const previous = monthlyData[monthlyData.length - 2];
    const change = current.days - previous.days;
    const maxMonthDays = Math.max(...monthlyData.map((item) => item.days));
    const maxVisitDays = Math.max(...visitData.map((item) => item.days));

    const displayedVisitData = showMore ? visitData : visitData.slice(0, 6);

    const visibleXAxisLabels = useMemo(
        () => ["Jun '25", "Sep '25", "Dec '25", "Mar '26", "Jun '26"],
        []
    );

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app">
                <div style={{ background: "#ffffff", minHeight: "100vh", padding: 28 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 10,
                        }}
                    >
                        <Button
                            variant="light"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                border: "1px solid #d8dee4",
                                borderRadius: 14,
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                            }}
                        >
                            <ArrowLeft size={18} /> Go Back
                        </Button>

                        <Button variant="light" style={filterStyle}>
                            Last 12 Months <ChevronDown size={18} />
                        </Button>
                    </div>

                    <h1
                        style={{
                            fontSize: 38,
                            fontWeight: 600,
                            color: "#071C1F",
                            marginBottom: 24,
                        }}
                    >
                        Is our{" "}
                        <span style={{ color: "#079A9A" }}>
                            customer return time
                        </span>{" "}
                        improving?
                    </h1>

                    <Card style={mainCardStyle}>
                        <Card.Body style={{ padding: 23 }}>
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 360px",
                                    gap: 36,
                                    alignItems: "center",
                                }}
                                className="details-top-grid"
                            >
                                <div>
                                    <h2
                                        style={{
                                            fontSize: 42,
                                            fontWeight: 800,
                                            marginBottom: 8,
                                            color: "#071C1F",
                                        }}
                                    >
                                        {current.days} Days
                                    </h2>

                                    <p
                                        style={{
                                            fontSize: 17,
                                            color: "#17292b",
                                            marginBottom: 28,
                                        }}
                                    >
                                        taken by {current.customers} customers to visit again in{" "}
                                        {current.month}
                                    </p>

                                    <div
                                        style={{
                                            position: "relative",
                                            height: 220,
                                            display: "flex",
                                            alignItems: "flex-end",
                                            gap: 18,
                                            borderBottom: "2px solid #edf0f2",
                                            padding: "0 14px",
                                        }}
                                    >
                                        {monthlyData.map((item, index) => {
                                            const height = Math.max(
                                                (item.days / maxMonthDays) * 230,
                                                7
                                            );
                                            const active = index >= monthlyData.length - 2;

                                            return (
                                                <div
                                                    key={item.month}
                                                    style={{
                                                        flex: 1,
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                    }}
                                                    onMouseEnter={() => setHoveredBar(index)}
                                                    onMouseLeave={() => setHoveredBar(null)}
                                                >
                                                    {hoveredBar === index && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                bottom: height + 18,
                                                                width: 240,
                                                                background: "#fff",
                                                                borderRadius: 16,
                                                                padding: 12,
                                                                boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
                                                                zIndex: 100,
                                                                textAlign: "left",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    fontSize: 12,
                                                                    fontWeight: 700,
                                                                    color: "#071C1F",
                                                                    marginBottom: 10,
                                                                }}
                                                            >
                                                                {item.month}
                                                            </div>

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    marginBottom: 10,
                                                                    fontSize: 14,
                                                                }}
                                                            >
                                                                <span style={{ color: "#64748B" }}>
                                                                    TBV
                                                                </span>

                                                                <strong>{item.days} Days</strong>
                                                            </div>

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    marginBottom: 10,
                                                                    fontSize: 14,
                                                                }}
                                                            >
                                                                <span style={{ color: "#64748B" }}>
                                                                    Customers
                                                                </span>

                                                                <strong>{item.customers}</strong>
                                                            </div>

                                                            {index > 0 && (
                                                                <>
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            fontSize: 11,
                                                                        }}
                                                                    >
                                                                        <span style={{ color: "#64748B" }}>
                                                                            Compared to Last Month
                                                                        </span>

                                                                        <strong
                                                                            style={{
                                                                                color:
                                                                                    item.days > monthlyData[index - 1].days
                                                                                        ? "#EF4444"
                                                                                        : item.days < monthlyData[index - 1].days
                                                                                            ? "#16A34A"
                                                                                            : "#475569",
                                                                            }}
                                                                        >
                                                                            {item.days > monthlyData[index - 1].days
                                                                                ? `+${item.days - monthlyData[index - 1].days} Days`
                                                                                : item.days < monthlyData[index - 1].days
                                                                                    ? `${item.days - monthlyData[index - 1].days} Days`
                                                                                    : "No Change"}
                                                                        </strong>
                                                                    </div>
                                                                </>
                                                            )}

                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    bottom: -8,
                                                                    left: "50%",
                                                                    transform: "translateX(-50%) rotate(45deg)",
                                                                    width: 16,
                                                                    height: 16,
                                                                    background: "#fff",
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            height,
                                                            background: active ? "#13b39b" : "#dfe7e8",
                                                            borderRadius: "7px 7px 0 0",
                                                            cursor: "pointer",
                                                            transition: "all .25s",
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: 12,
                                            color: "#6b7c7f",
                                            fontSize: 13,
                                        }}
                                    >
                                        {visibleXAxisLabels.map((label) => (
                                            <span key={label}>{label}</span>
                                        ))}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        background:
                                            change > 0
                                                ? "linear-gradient(135deg, #ffe5e5 20%, #fcfcfc 100%)"
                                                : "linear-gradient(135deg, #b5ffe2 0%, #fcfcfc 100%)",
                                        border: "1px solid #FECACA",
                                        borderRadius: 18,
                                        padding: 18,
                                    }}
                                >
                                    <h3
                                        style={{
                                            fontSize: 18,
                                            fontWeight: 800,
                                            marginBottom: 12,
                                            color: "#071C1F",
                                        }}
                                    >
                                        ⏳ {change > 0 ? "Longer Return Time" : "Better Return Time"}
                                    </h3>

                                    <p style={{ fontWeight: 700, marginBottom: 14 }}>
                                        Time Between Visits {change > 0 ? "increased" : "decreased"} by{" "}
                                        {Math.abs(change)} days
                                    </p>

                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            background: "#ffffff",
                                            color: change > 0 ? "#ef5350" : "#07996F",
                                            padding: "7px 12px",
                                            borderRadius: 20,
                                            fontWeight: 700,
                                            fontSize: 13,
                                            marginBottom: 18,
                                        }}
                                    >
                                        {change > 0 ? (
                                            <ArrowUpCircle size={16} />
                                        ) : (
                                            <ArrowDownCircle size={16} />
                                        )}
                                        Lower the Better
                                    </span>

                                    <CompareLine
                                        color="#ef5350"
                                        label="1 Jun '26 - 30 Jun '26"
                                        value={`${current.days} Days`}
                                        days={current.days}
                                        maxDays={maxMonthDays}
                                    />

                                    <CompareLine
                                        color="#344244"
                                        label="1 May '26 - 31 May '26"
                                        value={`${previous.days} Days`}
                                        days={previous.days}
                                        maxDays={maxMonthDays}
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                    <h2
                        style={{
                            fontSize: 34,
                            fontWeight: 600,
                            color: "#071C1F",
                            margin: "34px 0 22px",
                        }}
                    >
                        How many days do customers take to{" "}
                        <span style={{ color: "#079A9A" }}>visit again?</span>
                    </h2>

                    <Card style={mainCardStyle}>
                        <Card.Body style={{ padding: 21 }}>
                            {displayedVisitData.map((item, index) => {
                                const width = `${(item.days / maxVisitDays) * 100}%`;

                                const barColor =
                                    index === 0
                                        ? "#4B1FC9"      // darkest
                                        : index === 1
                                            ? "#7B5CF0"  // little lighter
                                            : "#B6A7F7"; // current color

                                return (
                                    <div
                                        key={item.visit}
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "170px 1fr",
                                            alignItems: "center",
                                            gap: 18,
                                            marginBottom: 22,
                                        }}
                                        className="visit-row"
                                    >
                                        <div style={{ fontSize: 14, fontWeight: 600, color: "#17292b" }}>
                                            Between visit {item.visit.replace("-", " - ")}
                                        </div>

                                        <div
                                            style={{
                                                position: "relative",
                                                height: 42,
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                            onMouseEnter={() => setHoveredBar(`visit-${index}`)}
                                            onMouseLeave={() => setHoveredBar(null)}
                                        >
                                            {hoveredBar === `visit-${index}` && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        bottom: 54,
                                                        left: `calc(${width} / 2)`,
                                                        transform: "translateX(-50%)",
                                                        width: 230,
                                                        background: "#fff",
                                                        borderRadius: 16,
                                                        padding: 12,
                                                        boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
                                                        zIndex: 100,
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            color: "#071C1F",
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        Between visit {item.visit.replace("-", " - ")}
                                                    </div>

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        <span style={{ color: "#64748B" }}>Customers</span>
                                                        <strong>{item.customers}</strong>
                                                    </div>

                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            bottom: -8,
                                                            left: "50%",
                                                            transform: "translateX(-50%) rotate(45deg)",
                                                            width: 16,
                                                            height: 16,
                                                            background: "#fff",
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <div
                                                style={{
                                                    width,
                                                    height: "100%",
                                                    background: barColor,
                                                    borderRadius: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: index === 0 ? "flex-end" : "flex-start",
                                                    padding: "0 14px",
                                                    position: "relative",
                                                    transition: "0.3s",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {index === 0 && (
                                                    <span
                                                        style={{
                                                            color: "#fff",
                                                            fontWeight: 700,
                                                            fontSize: 15,
                                                        }}
                                                    >
                                                        {item.days} {item.days > 1 ? "days" : "day"}
                                                    </span>
                                                )}
                                            </div>

                                            {index !== 0 && (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        left: `calc(${width} + 16px)`,
                                                        fontWeight: 700,
                                                        fontSize: 15,
                                                        color: "#1E293B",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {item.days} {item.days > 1 ? "days" : "day"}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                            <button
                                type="button"
                                onClick={() => setShowMore(!showMore)}
                                style={{
                                    border: 0,
                                    background: "transparent",
                                    fontWeight: 800,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    marginTop: 8,
                                }}
                            >
                                {showMore ? "Show less" : "Show more"}
                                {showMore ? <ChevronUp /> : <ChevronDown />}
                            </button>
                        </Card.Body>
                    </Card>
                </div>

                <style>
                    {`
                    tbody tr {
                        background: #f7fbfb;
                        border-radius: 14px;
                    }

                    tbody td {
                        padding: 18px 20px !important;
                        font-weight: 600;
                        color: #344244;
                    }

                    tbody tr td:first-child {
                        border-radius: 14px 0 0 14px;
                    }

                    tbody tr td:last-child {
                        border-radius: 0 14px 14px 0;
                    }

                    @media (max-width: 992px) {
                        .details-top-grid {
                            grid-template-columns: 1fr !important;
                        }
                    }

                    @media (max-width: 768px) {
                        .visit-row {
                            grid-template-columns: 1fr !important;
                        }
                    }
                `}
                </style>
            </div>
            <div className='mt-4'>
                <Footer />
            </div>
        </React.Fragment>
    );
};

const CompareLine = ({ color, label, value, days, maxDays }) => {
    const lineWidth = Math.max((days / maxDays) * 180, 40);

    return (
        <div style={{ marginBottom: 12 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 16,
                    marginBottom: 4,
                }}
            >
                <div
                    style={{
                        width: lineWidth,
                        height: 12,
                        borderRadius: 10,
                        background: color,
                        transition: "width .35s ease",
                    }}
                />

                <strong>{value}</strong>
            </div>

            <div style={{ color: "#5f7073", fontSize: 12 }}>
                {label}
            </div>
        </div>
    );
};

const tabStyle = {
    border: "1px solid #d8dee4",
    borderRadius: 10,
    fontWeight: 700,
    color: "#17292b",
    padding: "11px 16px",
};

const activeTabStyle = {
    background: "#079A9A",
    border: "1px solid #079A9A",
    borderRadius: 10,
    fontWeight: 800,
    padding: "11px 18px",
};

const filterStyle = {
    border: "1px solid #d8dee4",
    borderRadius: 10,
    fontWeight: 600,
    color: "#17292b",
    padding: "11px 16px",
    display: "flex",
    alignItems: "center",
    gap: 40,
};

const mainCardStyle = {
    border: "1px solid #dce5e7",
    borderRadius: 18,
    boxShadow: "none",
};

export default CustomerReturnTimeDetails;